import { apiClient } from "./api";

export const companyService = {
  get: () => apiClient.get("/company").then((r) => r.data),
  update: (body) => apiClient.put("/company", body).then((r) => r.data),
  uploadLogo: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return apiClient
      .post("/company/logo", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  removeLogo: () => apiClient.delete("/company/logo").then((r) => r.data),
};

export const filesService = {
  getBlob: (path) =>
    apiClient.get(`/files/${path}`, { responseType: "blob" }).then((r) => r.data),
};
